
import React from 'react'

class UiFooter extends React.Component {

    static defaultProps = {
        bg: ''
    };

    render() {
        const _class = 'container-fluid justify-content-end ' + this.props.bg;
        const _text = this.props.bg === 'bg-dark' ? ' text-light' :'';
        return (
            <div>
                <div className= 'm-4'> </div>
            <div className="navbar navbar-fixed-bottom navbar-expand">
                <div className={_class}>
                    <div className={"p-3 " + _text}>
                        &copy; acuadori 2020
                    </div>
                </div>
            </div>
            </div>
        );
    }
}

export default UiFooter;